import { Link } from "react-router-dom";
import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import LooxsLogo from "@/components/LooxsLogo";
import LooxsEmblem from "@/components/LooxsEmblem";

// Static navigation manifests — module-scope so they don't churn on every render.
const HOUSE_LINKS = [["/world","World"],["/chapters","Chapters"],["/campaigns","Campaigns"],["/about","About LOOXS"]];
const SHOP_LINKS  = [["/collections","Collections"],["/gifts","Gift Cards"],["/stores","Boutiques"],["/account","My Orders"]];
const CARE_LINKS  = [["/faq","FAQ"],["/careers","Careers"],["/contact","Contact"],["/account","Account"]];

export default function Footer() {
  const [email, setEmail] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try { await api.post("/newsletter", { email }); toast.success("You are on the list."); setEmail(""); }
    catch { toast.error("Please try again."); }
  };
  return (
    <footer style={{ background: "#e5dbc7", color: "#2b1f14" }} className="relative">
      <div className="max-w-[1400px] mx-auto px-8 md:px-16 py-24">
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="mb-6"><LooxsLogo height={80} /></div>
            <p className="text-[10px] tracking-luxury uppercase text-goldDark mb-4">Style in flicks</p>
            <p className="font-editorial text-3xl md:text-4xl leading-tight tracking-tight">11 Categories. <em className="font-editorial-italic text-goldDark">One identity.</em><br />London Wear.</p>
            <p className="mt-8 text-sm text-ink/70 leading-relaxed max-w-md">A private correspondence — reveals of new chapters, private previews and appointment access.</p>
            <form onSubmit={submit} className="mt-6 flex gap-3 max-w-md border-b border-ink/25 focus-within:border-goldDark transition-colors">
              <input data-testid="newsletter-email" required type="email" placeholder="your@email.com" value={email} onChange={(e)=>setEmail(e.target.value)}
                className="flex-1 bg-transparent py-3 outline-none placeholder:text-ink/40 tracking-wide" />
              <button data-testid="newsletter-submit" className="tracking-widest-plus text-[11px] uppercase text-goldDark hover:text-ink transition-colors">Subscribe →</button>
            </form>
          </div>

          <FCol title="House" links={HOUSE_LINKS} />
          <FCol title="Shop"  links={SHOP_LINKS}  />
          <FCol title="Care"  links={CARE_LINKS}  />

          <div className="md:col-span-2">
            <h3 className="text-[10px] tracking-widest-plus uppercase text-goldDark mb-6">Headquarters</h3>
            <p className="text-sm text-ink/80 leading-relaxed">
              LOOXS Headquarters<br />
              1, Station Road<br />
              Mohammad Azad Ahmad, Basement<br />
              Zeb Tower, Husainganj Chauraha<br />
              Husainganj, Lucknow — 226001<br />
              Uttar Pradesh, India
            </p>
          </div>
        </div>
      </div>
      <div className="border-t border-ink/10">
        <div className="max-w-[1400px] mx-auto px-8 md:px-16 pt-10 pb-4 flex flex-col items-center gap-3">
          <LooxsEmblem size={44} />
          <p className="font-editorial-italic text-goldDark text-lg tracking-wide">A Style in Flicks</p>
        </div>
        <div className="max-w-[1400px] mx-auto px-8 md:px-16 py-6 flex flex-col md:flex-row items-center justify-between text-[10px] tracking-widest-plus uppercase text-ink/50 gap-4">
          <div className="flex items-center gap-6 flex-wrap justify-center">
            <span>© {new Date().getFullYear()} LOOXS</span>
            <Link className="link-draw" to="/terms">Terms</Link>
            <Link className="link-draw" to="/cookies">Privacy</Link>
            <Link className="link-draw" to="/shipping">Shipping</Link>
            <Link className="link-draw" to="/returns">Returns</Link>
            <Link className="link-draw" to="/cookies">Cookies</Link>
          </div>
          <span>Designed in London · Crafted &amp; shipped from India</span>
        </div>
      </div>
    </footer>
  );
}

function FCol({ title, links }) {
  return (
    <div className="md:col-span-1">
      <h3 className="text-[10px] tracking-widest-plus uppercase text-goldDark mb-6">{title}</h3>
      <ul className="space-y-3 text-sm">
        {links.map(([to, label]) => (<li key={to}><Link className="link-draw" to={to}>{label}</Link></li>))}
      </ul>
    </div>
  );
}
